import { render, staticRenderFns } from "./WallMapBlockSettings.vue?vue&type=template&id=ed96134c"
import script from "./WallMapBlockSettings.vue?vue&type=script&lang=js"
export * from "./WallMapBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports